/**
 * Tech Assessment MCQ helpers — option uniqueness after case-fold and
 * whitespace-insensitive comparison ("Load Testing" == "LoadTesting").
 */

/**
 * Normalize an option for duplicate comparison: lower-case and strip ALL
 * whitespace so internal spacing differences do not create pseudo-unique
 * options.
 * @param {string} value
 * @returns {string}
 */
export function normalizeOption(value) {
  return String(value ?? '').toLowerCase().replace(/\s+/g, '');
}

/**
 * @param {string[]} options
 * @returns {boolean} true when every option is distinct after normalization
 */
export function areOptionsUnique(options) {
  if (!Array.isArray(options) || options.length === 0) return true;
  const normalized = options.map(normalizeOption);
  return new Set(normalized).size === normalized.length;
}
